import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';
import './control.css';
import './Textarea.css';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

/**
 * Multi-line text control. Shares the form-control vocabulary; vertical resize
 * only so layout stays predictable. Wrap with {@link Field} for label/error.
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid, className, rows = 4, 'aria-invalid': ariaInvalid, ...rest },
  ref,
) {
  const isInvalid = invalid || ariaInvalid === true || ariaInvalid === 'true';
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={cn('control', 'textarea', className)}
      aria-invalid={isInvalid || undefined}
      {...rest}
    />
  );
});
